import { render } from "./AddEditMeeting.vue?vue&type=template&id=2472077c&scoped=true&ts=true"
import script from "./AddEditMeeting.vue?vue&type=script&lang=ts"
export * from "./AddEditMeeting.vue?vue&type=script&lang=ts"

import "./AddEditMeeting.vue?vue&type=style&index=0&id=2472077c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2472077c"]])

export default __exports__